import { useQuery } from '@apollo/client';
import { get } from 'lodash';

import { GET_TASK_LIST_TEMPLATE_SECTIONLESS } from '../../gql/getTaskListTemplate.graphql';

const useSectionlessTemplates = (taskListTemplateId) => {
  const { data, loading, refetch, error } = useQuery(
    GET_TASK_LIST_TEMPLATE_SECTIONLESS,
    {
      variables: {
        id: taskListTemplateId,
      },
    },
  );

  return {
    sectionlessTemplateTasks: get(
      data,
      'viewer.taskListTemplate.taskTemplates.nodes',
      [],
    ),
    sectionlessTemplateTasksLoading: loading,
    refetchSectionlessTemplateTasks: refetch,
    sectionlessTemplateTasksError: error,
  };
};

export default useSectionlessTemplates;
